export const TYPE_ERROR = [
    {
        value: 'DANH_DAU_LOI_HONG',
        name: 'Lỗi hỏng'
    },
    {
        value: 'DANH_DAU_SUA_MAY',
        name: 'Sửa may'
    },
    {
        value: 'KHAC',
        name: 'Khác'
    }
]